module.exports = __webpack_public_path__ + "media/images/story/top/step5_image-72dc4b09428b89c06249b6e83d84b73e.png";